<template>
  
  <BaseLayout>
    <router-view></router-view> <!-- Locul unde se afișează componentele rutei curente -->
  </BaseLayout>
</template>

<script>
import BaseLayout from "./components/BaseLayout.vue";

export default {
  components: {
    BaseLayout,
  },
};
</script>
